function openMobileNav() {
  document.getElementById('mobile-nav').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  document.getElementById('mobile-nav').classList.remove('open');
  document.body.style.overflow = '';
}

// ── POPUP LOGIC ──────────────────────────
let popupShown = localStorage.getItem('popupShown') === 'true';

function showPopup() {
  if (popupShown) return;
  popupShown = true;
  localStorage.setItem('popupShown', 'true');
  const overlay = document.getElementById('popup-overlay');
  const card = document.getElementById('popup-card');
  if (!overlay || !card) return;
  overlay.style.pointerEvents = 'auto';
  overlay.style.opacity = '1';
  card.style.transform = 'translateY(0)';
  document.body.style.overflow = 'hidden';
}

function closePopup() {
  const overlay = document.getElementById('popup-overlay');
  const card = document.getElementById('popup-card');
  if (!overlay || !card) return;
  overlay.style.opacity = '0';
  overlay.style.pointerEvents = 'none';
  card.style.transform = 'translateY(24px)';
  document.body.style.overflow = '';
  localStorage.setItem('popupShown', 'true');
}

// Close on overlay click
const popupOverlay = document.getElementById('popup-overlay');
if (popupOverlay) {
  popupOverlay.addEventListener('click', function(e) {
    if (e.target === this) closePopup();
  });
}

// Show after 4 seconds
setTimeout(showPopup, 4000);

// Exit intent
document.addEventListener('mouseleave', function(e) {
  if (e.clientY < 10) showPopup();
});

// ── INITIAL FADE-IN ──────────────────────────
const initFades = document.querySelectorAll('.fade');
initFades.forEach(el => {
  const rect = el.getBoundingClientRect();
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    el.classList.add('in');
  }
});
document.body.classList.add('js-ready');

const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
}, { threshold: 0 });
initFades.forEach(el => { if (!el.classList.contains('in')) obs.observe(el); });

// ── FAQ ACCORDION ──────────────────────────
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ── VIDEO CAROUSEL ──────────────────────────
let vidPage = 0;
function slideVids(dir) {
  const track = document.getElementById('vidTrack');
  if (!track) return;
  const items = track.querySelectorAll('.vid-carousel-item');
  const perPage = window.innerWidth <= 768 ? 1 : 4;
  const totalPages = Math.ceil(items.length / perPage);
  vidPage = Math.max(0, Math.min(vidPage + dir, totalPages - 1));
  const itemW = items[0].getBoundingClientRect().width;
  const gap = 12;
  track.style.transform = `translateX(-${vidPage * (itemW + gap) * perPage}px)`;
  document.getElementById('vidPrev').disabled = vidPage === 0;
  document.getElementById('vidNext').disabled = vidPage >= totalPages - 1;
  document.querySelectorAll('.vid-dot').forEach((d, i) => {
    d.style.background = i === vidPage ? 'var(--coral)' : 'rgba(176,72,48,0.2)';
  });
  items.forEach((item, i) => {
    const video = item.querySelector('video');
    if (!video) return;
    const visible = i >= vidPage * perPage && i < (vidPage + 1) * perPage;
    if (visible) { video.play().catch(() => {}); }
    else { video.pause(); }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const track = document.getElementById('vidTrack');
  if (!track) return;
  const items = track.querySelectorAll('.vid-carousel-item');
  const perPage = window.innerWidth <= 768 ? 1 : 4;
  items.forEach((item, i) => {
    const video = item.querySelector('video');
    if (!video) return;
    if (i < perPage) { video.play().catch(() => {}); }
    else { video.pause(); }
  });
});

function toggleVidSound(card) {
  const video = card.querySelector('video');
  const hint = card.querySelector('.vid-sound-hint');
  document.querySelectorAll('.vid-carousel-item video').forEach(v => { if (v !== video) v.muted = true; });
  document.querySelectorAll('.vid-sound-hint').forEach(h => { if (h !== hint) h.textContent = '🔇 Tap for sound'; });
  video.muted = !video.muted;
  hint.textContent = video.muted ? '🔇 Tap for sound' : '🔊 Sound on';
}

// ── PURCHASE TYPE TOGGLE ──────────────────────────
function setPurchaseType(type) {
  const onetime = document.getElementById('onetime-opts');
  const subscribe = document.getElementById('subscribe-opts');
  const toggleOnetime = document.getElementById('toggle-onetime');
  const toggleSubscribe = document.getElementById('toggle-subscribe');
  if (type === 'onetime') {
    onetime.style.display = '';
    subscribe.style.display = 'none';
    toggleOnetime.style.background = 'var(--terracotta)';
    toggleOnetime.style.color = '#fff';
    toggleSubscribe.style.background = 'var(--warm-white)';
    toggleSubscribe.style.color = 'var(--muted)';
    const firstOpt = onetime.querySelector('.buy-opt');
    if (firstOpt) firstOpt.click();
  } else {
    onetime.style.display = 'none';
    subscribe.style.display = '';
    toggleSubscribe.style.background = 'var(--terracotta)';
    toggleSubscribe.style.color = '#fff';
    toggleOnetime.style.background = 'var(--warm-white)';
    toggleOnetime.style.color = 'var(--muted)';
    const firstPlan = subscribe.querySelector('.buy-opt');
    if (firstPlan) firstPlan.click();
  }
}

// ── BUNDLE OPTION SELECTION ──────────────────────────
document.querySelectorAll('.buy-opt').forEach(opt => {
  opt.addEventListener('click', function() {
    document.querySelectorAll('.buy-opt').forEach(o => o.classList.remove('selected'));
    this.classList.add('selected');
  });
});

const product_price = document.querySelector('.ph-price');
const productImage = document.getElementById('product-image');

// ── VARIANT SELECTION ──────────────────────────
function selectVariant(el, variantId) {
  variantId = Number(variantId);
  document.querySelectorAll('.buy-opt').forEach(o => o.classList.remove('selected'));
  el.classList.add('selected');
  const atcBtn = document.getElementById('atc-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const variant = productData.variants.find(v => v.id === variantId);
  if (variant) {
    const variantPrice = variant.price / 100;
    const days = parseInt(el.dataset.days) || 30;
    const perDay = (variant.price / days / 100).toFixed(2);
    if (product_price) product_price.innerHTML = '$' + variantPrice.toFixed(2) + ' USD <span style="font-size:0.82rem;color:var(--muted);font-weight:300;" id="price_per_day">· $' + perDay + ' USD/day</span>';
    if (productImage && variant.featured_image) productImage.src = variant.featured_image.src;
  }
  if (atcBtn) { atcBtn.dataset.id = variantId; delete atcBtn.dataset.planId; }
  if (stickyBtn) { stickyBtn.dataset.id = variantId; delete stickyBtn.dataset.planId; }
}

function selectSubscriptionPlan(el, variantID, planID) {
  const productPrice = document.querySelector('.ph-price');
  const discountPrice = document.querySelector('#discount_price');
  document.querySelectorAll('#subscribe-opts .buy-opt').forEach(o => o.classList.remove('selected'));
  el.classList.add('selected');
  const atcBtn = document.getElementById('atc-btn');
  const variant = productData.variants.find(v => v.id === parseInt(variantID));
  if (productPrice && discountPrice) {
    const priceText = discountPrice.textContent.replace(/[^0-9.]/g, '');
    const price = parseFloat(priceText);
    const selectedOpt = document.querySelector('#subscribe-opts .buy-opt.selected');
    const days = parseInt(selectedOpt && selectedOpt.dataset.days) || 30;
    const perDay = (price / days).toFixed(2);
    productPrice.innerHTML = discountPrice.textContent + ' <span style="font-size:0.82rem;color:var(--muted);font-weight:300;" id="price_per_day">· $' + perDay + ' USD/day</span>';
  }
  if (atcBtn) { atcBtn.dataset.id = variantID; atcBtn.dataset.planId = planID; }
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (stickyBtn) { stickyBtn.dataset.id = variantID; stickyBtn.dataset.planId = planID; }
  if (variant && productImage && variant.featured_image) productImage.src = variant.featured_image.src;
}

// ── STICKY ATC ──────────────────────────
function stickyAtcObserver() {
  const stickyBar = document.getElementById('sticky-atc');
  if (!stickyBar) return;
  const atcBtn = document.getElementById('atc-btn')
    || document.getElementById('home-hero-cta')
    || document.querySelector('.product-hero')
    || document.querySelector('.hero')
    || document.querySelector('h1');
  if (!atcBtn) return;
  const o = new IntersectionObserver(entries => {
    entries.forEach(e => {
      stickyBar.classList.toggle('visible', !e.isIntersecting);
    });
  }, { threshold: 0 });
  o.observe(atcBtn);
}

stickyAtcObserver();

$(document).ready(function(){
  
})


// product-slider js start---
var swiper = new Swiper(".product-slider-thumb", {
  loop: false,
  spaceBetween: 15,
  slidesPerView: 5,
  freeMode: true,
  mousewheel: true,
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 10,
      slidesPerView: 4,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 15,
      slidesPerView: 5,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 15,
      slidesPerView: 5,
    },
  },
});
var swiper2 = new Swiper(".product-slider", {
  loop: true,
  autoHeight: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
